import React from "react";
import { capitalize } from "../../utils/textFunctions";

const Race = ({ data }) => (
  <div>
    <h4>Race</h4>
    {data.map((race, index) => (
      <div key={index}>
        {race.extension[0].valueCoding.display
          ? capitalize(race.extension[0].valueCoding.display)
          : race.extension[0].valueCoding.code}
      </div>
    ))}
  </div>
);

export default Race;
